module.exports = __webpack_public_path__ + "img/ICON_PieChart_ThreeColors.519f996c.svg";